<script>
export default {
  props: ['books'],
  data() {
    return {
      searchQuery: '',
    }
  },
  mounted() {
  },
  computed: {
   results() {
    if(this.searchQuery){
      return this.books.filter((item)=>{
        return this.searchQuery.toLowerCase().split(' ').every(v => item.title.toLowerCase().includes(v) || item.author.toLowerCase().includes(v) || item.publisher.toLowerCase().includes(v))
      })
      }else{
        return this.books;
      }
    }
  }
}
</script>